/*
 * Before updating the version, make sure you have
 * added the necessary migrations as described
 * in the "Creating a new version for types" section of the
 * README.
 */
export var currentUiVersion = 0;
